import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    hcommerceStoreSkuData: {},
};

const storeInfoSlice = createSlice({
    name: 'storeInfo',
    initialState,
    reducers: {
        setHcommerceStoreSkuData: (state, action) => {
            state.hcommerceStoreSkuData = { 
                ...state.hcommerceStoreSkuData,
                ...action.payload
            };
        },
    },
});

export const { setHcommerceStoreSkuData } = storeInfoSlice.actions;

export default storeInfoSlice.reducer;
